import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getStoredConsent, saveConsent } from '../utils/cookieConsent';
import { applyConsentState } from '../utils/analytics';
import './CookiePreferencesDialog.css';

const CookiePreferencesDialog = ({ open, onClose, onSaved }) => {
  const { t } = useTranslation('common');
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (open) {
      const stored = getStoredConsent();
      setAnalytics(stored?.analytics ?? false);
    }
  }, [open]);

  if (!open) {
    return null;
  }

  const handleSave = () => {
    saveConsent({ analytics });
    applyConsentState();
    onSaved?.();
    onClose?.();
  };

  return (
    <div className="cookie-preferences-overlay" role="presentation" onClick={onClose}>
      <div
        className="cookie-preferences-dialog"
        role="dialog"
        aria-labelledby="cookie-preferences-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cookie-preferences-title">{t('cookiePreferencesTitle')}</h2>
        <p className="cookie-preferences-dialog__intro">{t('cookiePreferencesIntro')}</p>

        <div className="cookie-preferences-dialog__category">
          <div className="cookie-preferences-dialog__category-header">
            <h3>{t('cookieEssentialTitle')}</h3>
            <span className="cookie-preferences-dialog__always-on">{t('cookieEssentialAlwaysOn')}</span>
          </div>
          <p>{t('cookieEssentialDescription')}</p>
        </div>

        <div className="cookie-preferences-dialog__category">
          <div className="cookie-preferences-dialog__category-header">
            <h3>{t('cookieAnalyticsTitle')}</h3>
            <label className="cookie-preferences-dialog__toggle">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
              />
              <span>{analytics ? t('enabled') : t('disabled')}</span>
            </label>
          </div>
          <p>{t('cookieAnalyticsDescription')}</p>
        </div>

        <div className="cookie-preferences-dialog__actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            {t('cancel')}
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSave}>
            {t('savePreferences')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiePreferencesDialog;
